import { render, staticRenderFns } from "./RecebimentoNaoIdentificados.vue?vue&type=template&id=046c2a9a&"
import script from "./RecebimentoNaoIdentificados.vue?vue&type=script&lang=js&"
export * from "./RecebimentoNaoIdentificados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports